export let props = ['text', 'width', 'height', 'minHeight','backgroundColor']
export let model = {}
export let computed = {
  emptyStyle(){
    // `width:${width||'100%'};height:${height||(minHeight?'auto':'150px')};min-height:${minHeight||'auto'}`"
    const s = {
      width:this.width || '100px',
      height:this.height || (this.minHeight?'auto':'150px'),
      minHeight:this.minHeight || 'auto',
    }
    if (this.backgroundColor){
      s.backgroundColor = this.backgroundColor
    }
    return s;
  }
}
